import { gql } from '@apollo/client';

export const ALL_SCHOOLS = gql`
  query AllSchools($input: ExportArgs) {
    schools: allServiceProviderSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          emisNumber
        }
      }
    }
  }
`;
